import React from 'react';
import './presentation.scss';

import { umoksType } from '../../types/types.js';
import CVideo  from '../video/cvideo.js';
class Presentation extends React.Component {
  constructor(props) {
    super(props);
  };

    getTitle = () => {
      const { presentationList } = this.props;

      return presentationList && presentationList.title;
    };

    getList = () => {
      const { presentationList } = this.props;

      return presentationList && presentationList.content.map((item, i, arr) => {
        return (
          <div key={'presentation-img-wrap-' + i}   className='f-item f-item-4'>
            <a href={item.ref} className='presentation-img-wrap'>
              <img src={item.img}/>
              <p>{item.title}</p>
            </a>
          </div>
        );
      });
    };


    render() {
      return (
        <div>
          <section className='presentation-wrap f-center'>
            <div className='f-container'>
              <h2>{this.getTitle()}</h2>
              <div className='f-row'>
                {this.getList()}
              </div>

            </div>
          </section>
          <CVideo/>
        </div>

      );
    };
};

Presentation.propTypes = {
  presentationList:umoksType.isRequired
};

export default  Presentation;



// WEBPACK FOOTER //
// ./src/client/components/presentation/presentation.jsx